module.exports = __webpack_public_path__ + "img/342ee8c9e8af4658a5ffea6dc54bcfe5-640.5612de61.jpg";